<dx-popup
  [(visible)]="visible"
  [showTitle]="true"
  [title]="isEditing ? 'Modifier l\'Évaluation' : 'Évaluer la Précision des Données'"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [width]="500"
  height="auto"
  (onHiding)="close()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="p-4 space-y-4">
      <div>
        <label class="block mb-2 font-medium">Précision des Données *</label>
        <dx-select-box
          [dataSource]="ratingOptions"
          displayExpr="label"
          valueExpr="value"
          [(value)]="selectedRating"
          placeholder="Sélectionner une évaluation"
          [searchEnabled]="false">
        </dx-select-box>
      </div>
    </div>
    
    <div class="p-4 border-t">
      <dx-button
        [text]="isEditing ? 'Modifier' : 'Enregistrer'"
        type="success"
        (onClick)="submit()"
        [disabled]="!selectedRating"
        class="mr-2">
      </dx-button>
      <dx-button
        text="Annuler"
        (onClick)="close()">
      </dx-button>
    </div>
  </div>
</dx-popup>

